export const postulacionesStatistics = {
  empty: {
    subtitle: '¡Volvé en otro momento!',
  },
}
